import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../../../@types/filter";
import { AttendanceLocalDepartment } from "../../../../@types/attendance-local-department";
import { Paginated } from "../../../../@types/paginated";
import { apisiseci } from "../../../api";
import { useDefaultSearchParams } from "../../../../hooks/useSearchParams";
import { AxiosError } from "axios";

type Props = DefaultFilter & {
  unidade_slug?: string;
};

export function useAttendanceLocalDepartmentList(params?: Props) {
  const token = localStorage.getItem("gov_access_token_sso");
  const defaultParams = useDefaultSearchParams();
  params = { ...defaultParams, ...params };

  return useQuery<Paginated<AttendanceLocalDepartment>, AxiosError<{ detail: string }>>({
    enabled: !!token,
    queryKey: ["attendance-local", "department", "list", params],
    queryFn: async () => {
      const response = await apisiseci.get<
        Paginated<AttendanceLocalDepartment>
      >("/cms/setor_unidade/", {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });
      return response.data;
    },
  });
}
